export const businessNameValidationErrors = {
  required: _TL_('Field must not be empty'),
  type: _TL_('Invalid Character'),
  maxLength: _TL_('Maximum length exceeded'),
  minLength: _TL_('Minimum length not met'),
};

export const websiteValidationErrors = {
  required: _TL_('Business website is required'),
  maxLength: _TL_('Business website exceeds the maximum allowed length'),
  pattern: _TL_('Enter a valid business website'),
};

export const URLError = {
  UrlNotAccessible: _TL_('Cannot access business website. Enter a valid business website.'),
  InvalidValue: _TL_('Cannot access business website. Enter a valid business website.'),
  InvalidWebsiteUrl: _TL_('Cannot access business website. Enter a valid business website.'),
  BlockedByCloudflare: _TL_('Cannot access business website due to Cloudflare protection. Check your website configuration.'),
  UrlSSLVerificationFailed: _TL_('Your website\'s SSL certificate validation failed. Check your website configuration.'),
  UrlScanFailed: _TL_('We are not able to scan your website. Check your website configuration.'),
};
